module.exports = {
  ALL: [{
      name: "實體卡",
      logo: "category_mycard.png",
      amount: {
        TWD: [50,150,300]
      },
      itemCode: {"50": "Enjoy50", "150": "Enjoy150", "300": "Enjoy300",}
  }]
}



// WEBPACK FOOTER //
// ./src/config/pay/lunamycard.js